// TODO: Unify the naming of the providers with their plain value inorder to use them as enums and improve typing.
// e.g. "WPI_NEQUI", "WPI_PSE", "WPI_BANCOLOMBIA", "WPI_BANCOLOMBIA_CORRESPONSAL", "WPI_BOTON_DAVIPLATA", "FELIX".
export const Providers = {
    /**
     * This is a copy of the FE SDK enum PaymentProviderTypes
     * Please keep this updated.
     * */
    OXXO: "OXXO",
    SPEI: "SPEI",
    CODI: "CODI",
    OPENPAY: "OPENPAY",
    IN_STORE: "IN_STORE",
    STRIPE: "STRIPE",
    D_LOCAL: "D_LOCAL",
    STP: "STP",
    REFACIL: "REFACIL",
    EFECTY: "EFECTY",
    BANCOLOMBIA: "BANCOLOMBIA",
    MOVII: "MOVII",
    OXXO_DIRECT: "OXXO_DIRECT",
    RED_ACTIVA: "RED_ACTIVA",
    WOMPI: "WOMPI",
    WOMPI_NEQUI: "WPI_NEQUI",
    WOMPI_PSE: "WPI_PSE",
    WOMPI_BOTON_BANCOLOMBIA: "WPI_BANCOLOMBIA",
    WOMPI_BANCOLOMBIA_CORRESPONSAL: "WPI_BANCOLOMBIA_CORRESPONSAL",
    WOMPI_DAVIPLATA: "WPI_BOTON_DAVIPLATA",
    SIX: "SIX",
    FLASH: "FLASH",
    KASNET: "KASNET",
    FELIX_PAGO: "FELIX",
    PUNTO_PAGO: "PUNTO_PAGO",
    WESTERN_UNION: "WESTERN_UNION",
    BCP: "BCP",
    INTERBANK: "INTERBANK",
    CLAVE: "CLAVE",
    D_LOCAL_GCASH: "D_LOCAL_GCASH",
    ASAAS: "ASAAS",
    ASAAS_PIX: "ASAAS_PIX",
    MULTIPAGOS: "MULTIPAGOS",
    PESPAY: "PESPAY",
    D_LOCAL_MAYA: "D_LOCAL_MAYA",
    D_LOCAL_SEVEN_ELEVEN: "D_LOCAL_SEVEN_ELEVEN",
};

export type PaymentProviderType = typeof Providers[keyof typeof Providers];